import styled from '@emotion/styled'
import { Container, Button, Paper, Box, Chip, Grid } from '@mui/material'
import { colors } from '../../../../Themes/Colors'

export const PageContainer = styled(Container)`
  padding: 24px;
  margin-bottom: 48px;
`

export const HeaderSection = styled.div`
  margin-bottom: 32px;
`

export const BackButton = styled(Button)`
  margin-bottom: 16px;
  color: ${colors.darkGrey};
  &:hover {
    background-color: ${colors.lightGrey};
  }
`

export const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 600;
  margin: 0 16px 0 0;
  color: ${colors.greyBlue};
`

export const Subtitle = styled.p`
  font-size: 16px;
  color: ${colors.mediumGrey};
  margin: 8px 0 0 0;
`

export const StatusChip = styled(Chip)<{
  status: 'active' | 'disabled' | 'test' | 'sponsored'
}>`
  margin-left: 8px;
  background-color: ${(props) => {
    switch (props.status) {
      case 'active':
        return '#e8f5e9'
      case 'disabled':
        return '#ffebee'
      case 'test':
        return '#fffde7'
      case 'sponsored':
        return '#e3f2fd'
      default:
        return colors.lightGrey
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case 'active':
        return colors.darkGreen
      case 'disabled':
        return colors.red
      case 'test':
        return '#f57c00'
      case 'sponsored':
        return '#1976d2'
      default:
        return colors.darkGrey
    }
  }};

  .MuiChip-icon {
    color: inherit;
  }
`

export const StatCard = styled(Paper)`
  height: 100%;
  background: #ffffff;
  border: 1px solid ${colors.lightGrey};
  border-radius: 8px;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  .MuiCardContent-root {
    text-align: center;
    padding: 24px;
  }
`

export const StatIcon = styled.div`
  color: ${colors.resiliaBlue};
  margin-bottom: 12px;
  opacity: 0.8;
`

export const StatValue = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: ${colors.greyBlue};
  line-height: 1;
`

export const StatLabel = styled.div`
  font-size: 14px;
  color: ${colors.mediumGrey};
  margin-top: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${colors.greyBlue};
  margin: 24px 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: ${colors.mediumGrey};
    font-size: 20px;
  }
`

export const InfoCard = styled(Paper)`
  background: #ffffff;
  border: 1px solid ${colors.lightGrey};
  border-radius: 8px;
  margin-bottom: 24px;
  overflow: hidden;
`

export const InfoGrid = styled(Grid)`
  margin-top: 16px;
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const InfoLabel = styled.div`
  font-size: 12px;
  color: ${colors.mediumGrey};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
`

export const InfoValue = styled.div`
  font-size: 14px;
  color: ${colors.greyBlue};
  display: flex;
  align-items: center;
  gap: 4px;

  svg {
    font-size: 16px;
    color: ${colors.mediumGrey};
  }

  a {
    color: ${colors.resiliaBlue};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`

export const ScrollablePanel = styled(Paper)`
  height: 300px;
  overflow-y: auto;
  background: #fafafa;
  border: 1px solid ${colors.lightGrey};
  border-radius: 8px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.lightGrey};
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.mediumGrey};
    border-radius: 4px;
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${colors.mediumGrey};
  text-align: center;
  padding: 24px;
`

export const ActionBar = styled(Box)`
  position: sticky;
  bottom: 0;
  background-color: ${colors.resiliaWhite};
  border-top: 1px solid ${colors.lightGrey};
  padding: 16px 0;
  margin-top: 32px;
  display: flex;
  gap: 16px;
  justify-content: center;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`

export const ErrorContainer = styled.div`
  text-align: center;
  padding: 48px 24px;
  color: ${colors.red};
`
